// extracted by mini-css-extract-plugin
export var legendIndicator = "_di-1";
export var legendRight = "_di-0";